export const gitVersion = '1.0.0-8-g917f4fc';
